import { render, staticRenderFns } from "./LazySingleImg.vue?vue&type=template&id=0041c196&"
import script from "./LazySingleImg.vue?vue&type=script&lang=js&"
export * from "./LazySingleImg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\JVolke\\Documents\\plentyDevTool\\38722\\18\\KrauseSohn\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0041c196')) {
      api.createRecord('0041c196', component.options)
    } else {
      api.reload('0041c196', component.options)
    }
    module.hot.accept("./LazySingleImg.vue?vue&type=template&id=0041c196&", function () {
      api.rerender('0041c196', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/src/app/components/common/LazySingleImg.vue"
export default component.exports